import * as SharedLib from '@cumul.io/shared-cumulio-dashboard';
import CumulioService from '../cumulio-service';

interface AppWindow extends Window {
  __cumulioMessageHandler(event: MessageEvent): void;
}

declare const window: AppWindow;

// create the Cumul.io event listener
export const _setEventHandler = (): void => {
  if (typeof window.__cumulioMessageHandler === 'function') {
    return;
  }

  window.__cumulioMessageHandler = (event: MessageEvent) => {
    const dashboardComponent = CumulioService._components.find((c) => event.data.name === c._iframeId);

    if (!dashboardComponent) {
      return;
    }

    switch (event.data?.type) {
      case 'load': {
        dashboardComponent.dispatchEvent(
          new CustomEvent('load', { detail: { data: event.data } })
        );

        if (dashboardComponent._loadTimeoutHandle) {
          clearTimeout(dashboardComponent._loadTimeoutHandle);
          dashboardComponent._loadTimeoutHandle = undefined;
        }

        dashboardComponent.iframeLoaded = true;
        dashboardComponent.dimensions = event.data.dimensions;
        // c.calculateIframeStyles();
        dashboardComponent._calculateDimAfterDashboardLoaded();
        break;
      }
      case 'error': {
        dashboardComponent.dashboardError = true;

        if (dashboardComponent._loadTimeoutHandle) {
          clearTimeout(dashboardComponent._loadTimeoutHandle);
          dashboardComponent._loadTimeoutHandle = undefined;
        }

        dashboardComponent.iframeLoaded = true;
        dashboardComponent._displayError();
        break;
      }
      case 'data': {
        SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data.data);
        break;
      }
      case 'filters': {
        SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data.filters);
        break;
      }
      case 'getAccessibleDashboards': {
        SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data.accessibleDashboards);
        break;
      }
      case 'dashboardAction': {
        dashboardComponent.dispatchEvent(
          new CustomEvent('dashboardAction', { detail: { data: event.data } })
        );
        break;
      }
      case 'export': {
        if (!event.data.error) {
          dashboardComponent.dispatchEvent(
            new CustomEvent('exported', { detail: { data: event.data } })
          );
          SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
        }
        else {
          SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data);
        }
        break;
      }
      case 'changedFilters': {
        dashboardComponent.dispatchEvent(
          new CustomEvent('changedFilters', { detail: { data: event.data } })
        );
        break;
      }
      case 'customEvent': {
        dashboardComponent.dispatchEvent(
          new CustomEvent('customEvent', { detail: { data: event.data } })
        );
        break;
      }
      case 'chartsRendered': // TODO remove once chartsRendered is changed to itemsRendered in FE app
      case 'itemsRendered': {
        event.data.type = 'itemsRendered';
        dashboardComponent.dispatchEvent(
          new CustomEvent('itemsRendered', { detail: { data: event.data } })
        );
        break;
      }
      case 'setEditMode': {
        if (!event.data.error) {
          SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
          dashboardComponent.params.editMode = event.data.editMode;
          // Update iframe + container dimensions.
          dashboardComponent._containerStyle = SharedLib.containerStyles(dashboardComponent);

          if (dashboardComponent.dimensions) {
            SharedLib._setCalculatedDimensions(dashboardComponent);
          }
        }
        else {
          SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data);
        }
        break;
      }
      case 'setFilters': {
        event.data.error
          ? SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data)
          : SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
        break;
      }
      case 'setPreview': {
        event.data.error
          ? SharedLib.rejectPromise(dashboardComponent, event.data.requestId, event.data)
          : SharedLib.resolvePromise(dashboardComponent, event.data.requestId, event.data);
        break;
      }
    }
  };

  window.addEventListener('message', window.__cumulioMessageHandler, false);
};
